import { initContactFloating } from './contact_floating';

export const initContact = (): void => {
  initContactFloating();
};
